import React from "react";
import Select from "react-select";
import BaseField from './BaseField'

export default function BooleanField(props){
  const { action, resource, name, label, col, onChange } = props;
  const options = [{ label: "Yes", value: true }, { label: "No", value: false }];
  const value = options.find((option) => option.value === props.value);

  return(
    <BaseField action={action} resource={resource} name={name} label={label} value={value ? value.label : null} col={col}>
      <Select value={value} options={options} onChange={onChange} isClearable/>
    </BaseField>
  )
}